import { gql } from '@apollo/client';

export const FETCH_CLOTHES = gql`
  query fetchClothes($limit: Int, $where: Editor_clothWhereInput) {
    editor_cloths(first: $limit, where: $where) {
      edges {
        node {
          objectId
          image {
            url
          }
          gender
          color
          prompt
          item
        }
      }
    }
  }
`;
